import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import {
  OfferSummaryInfoGroup,
  OfferSummaryInfoItem,
  OfferSummaryInfoLayout,
} from 'shared/components/OfferSummaryInfo';
import { FeaturesNewV2 } from 'shared/containers/FeaturesNew';
import { SubscribeButtonContainer, SaveSearchEventsContainer } from 'shared/containers/SavedSearchButtonContainer';
import { selectFeatures } from 'shared/selectors';

import { useShowSubscribeBtn } from './hooks/useShowSubscribeBtn';
import { trackAboutFlatAndHomeShow } from './tracking/tracking';

export const OfferSummaryInfoDailyRent: React.FC = () => {
  const features = useSelector(selectFeatures);

  const [firstFeature, secondFeature, ...othersFeatures] = features || [];

  const showSubscribeBtn = useShowSubscribeBtn(secondFeature);

  if (!firstFeature) {
    return null;
  }

  return (
    <ActionAfterViewed callback={trackAboutFlatAndHomeShow}>
      <CardSectionNew>
        <FeaturesNewV2 noTopMargin />

        <OfferSummaryInfoLayout>
          <OfferSummaryInfoGroup header={firstFeature.title}>
            {firstFeature.features.map(({ label, value }, index) => (
              <OfferSummaryInfoItem key={label + index} name={label} value={value} />
            ))}
          </OfferSummaryInfoGroup>

          {secondFeature && (
            <OfferSummaryInfoGroup
              header={secondFeature.title}
              actionButton={showSubscribeBtn ? <SubscribeButtonContainer /> : null}
              rightGroup
            >
              {secondFeature.features.map(({ label, value }, index) => (
                <OfferSummaryInfoItem key={label + index} name={label} value={value} />
              ))}
            </OfferSummaryInfoGroup>
          )}
        </OfferSummaryInfoLayout>

        {!!othersFeatures?.length && (
          <OfferSummaryInfoLayout>
            {othersFeatures.map(({ title, features }, index) => (
              <OfferSummaryInfoGroup key={title + index} header={title}>
                {features.map(({ label, value }, index) => (
                  <OfferSummaryInfoItem key={label + index} name={label} value={value} />
                ))}
              </OfferSummaryInfoGroup>
            ))}
          </OfferSummaryInfoLayout>
        )}

        {showSubscribeBtn ? <SaveSearchEventsContainer /> : null}
      </CardSectionNew>
    </ActionAfterViewed>
  );
};
